import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {get} from "mobx";
import {useRouter} from "@morningtrain/react-navigation";
import useConstrainable from "../hooks/use-constrainable";
import useWillClearConstrainOnUnmount from "../hooks/use-will-clear-constrain-on-unmount";

function RouteParameterFilter(props) {

    useWillClearConstrainOnUnmount(props.name);

    const constrainable = useConstrainable();
    const router = useRouter();

    const parameters = (router && router.current) ? router.current.parameters : {};

    const value = get(parameters, props.name);

    React.useEffect(() => {
        constrainable.setConstraint(props.name, value);
    });

    return null;
}

RouteParameterFilter.propTypes = {
  name: PropTypes.string.isRequired,
};

export default observer(RouteParameterFilter);
